import { FC } from 'react';
import CircleIcon from '@mui/icons-material/Circle';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import InfoIcon from '@mui/icons-material/Info';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import './styles.scss';

interface IProps {
  type: string;
}

const SnackbarIcon: FC<IProps> = ({ type }) => {
  let icon;
  switch (type) {
    case 'success':
      icon = <CheckIcon fontSize='medium' className='container__notificationIcon' />;
      break;
    case 'error':
      icon = <CloseIcon fontSize='medium' className='container__notificationIcon' />;
      break;
    case 'warning':
      icon = <PriorityHighIcon fontSize='medium' className='container__notificationIcon' />;
      break;
    case 'info':
      icon = <InfoIcon fontSize='large' className='container__infoIcon' />;
      break;
  }
  return (
    <div style={{ boxSizing: 'border-box' }}>
      <div className='container'>
        <CircleIcon fontSize='large' className={`container__circleIcon ${type}`} />
        {icon}
      </div>
    </div>
  );
};
export default SnackbarIcon;
